<template>
  <div>
    <router-view />

  </div>

</template>

<style>

</style>

<script>//script引进Header组件
import Header from "@/components/Header.vue";
import Aside from "@/components/Aside.vue";

export default {
  name:"App",

}
</script>